import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/",
    name: "index",
    component: () => import("@/views/Index.vue"),
    meta: {
      title: '好心理-互联网青少年儿童心理健康服务平台',
      content: {
        keywords: '好心理、青少年儿童心理健康、心理咨询、公益百讲、专家讲座',
        description: '北京视觉跳动科技有限公司-好心理，致力于打造专业的“儿童青少年心理健康服务平台”。 为学校、老师、家长、学生提供专业的心理测评、心理健康辅导、心理健康课程、全面普及儿童青少年心理健康教育。'
      }
    }
  },
  {
    path: '/m_index', // 手机端首页
    name: "m_index",
    component: () => import("@/views/m_Index.vue"),
    meta: {
      title: '好心理-互联网青少年儿童心理健康服务平台',
      content: {
        keywords: '好心理、青少年儿童心理健康、心理咨询、公益百讲、专家讲座',
        description: '北京视觉跳动科技有限公司-好心理，致力于打造专业的“儿童青少年心理健康服务平台”。 为学校、老师、家长、学生提供专业的心理测评、心理健康辅导、心理健康课程、全面普及儿童青少年心理健康教育。'
      }
    }
  },
  {
    path: "/dynamic",
    name: "dynamic",
    component: () => import("@/views/dynamic.vue"),
    meta: {
      title: '好心理-孩子生活中的心理解忧百科',
      content: {
        keywords: '心理资讯 家有儿女 心理百科 心理健康',
        description: '面对孩子与家长间心理困惑的专业解答与指导，提供生活与学习等多方面丰富的心理案例，让你更加了解孩子的心理世界。'
      }
    }
  },
  {
    path: "/Evaluation",
    name: "Evaluation",
    component: () => import("@/views/Evaluation.vue"),
    meta: {
      title: '好心理-孩子性格/情绪/情感的专业心理测评',
      content: {
        keywords: '心理测试、分类测试、趣味测试',
        description: '海量心理测评，将孩子心理健康进行分类，快速精准测评，专业准却且趣味了解藏在深处的小困扰。'
      }
    }
  },
  {
    path: "/curriculum",
    name: "curriculum",
    component: () => import("@/views/curriculum.vue"),
    meta: {
      title: '好心理-孩子心理成长的专家顾问',
      content: {
        keywords: '孩子教育、心理健康、情感困惑、学习障碍、情绪压力',
        description: '根据孩子心理困扰，运用专业心理教育方法，提供精准解决方案课程，促进孩子身心全面健康发展。'
      }
    }
  },
  {
    path: "/newdetails",
    name: "newdetails",
    component: () => import("@/views/newdetails.vue")
  },
  {
    path: "/Parent",
    name: "Parent",
    component: () => import("@/views/Parent.vue"),
    meta: {
      title: '针对家长、老师等群体提供专业的职业技能认证',
      content: {
        keywords: '职业资格证书、迅速通关、官网可查、全国通用、求职创业、健康管理、医药健康',
        description: '提供家长与教师相关技能认证，帮助家长、老师对少年儿童心理咨询和心理治疗的能力提升。'
      }
    }
  },
  {
    path: "/MoreCareers",
    name: "MoreCareers",
    component: () => import("@/views/MoreCareers.vue"),
    meta: {
      title: '好心理-互联网青少年儿童心理健康服务平台',
      content: {
        keywords: '好心理、青少年儿童心理健康、心理咨询、公益百讲、专家讲座',
        description: '北京视觉跳动科技有限公司-好心理，致力于打造专业的“儿童青少年心理健康服务平台”。 为学校、老师、家长、学生提供专业的心理测评、心理健康辅导、心理健康课程、全面普及儿童青少年心理健康教育。'
      }
    }
  },
  {
    path: "/Sansheng",
    name: "Sansheng",
    component: () => import("@/views/Sansheng.vue"),
    meta: {
      title: '生命体验教育',
      content: {
        keywords: '生命教育、生存教育、生活教育、三生体验馆',
        description: '通过环境设计或技术辅助，觉醒体验、生理功能剥夺体验、游戏等，让人“设身处地”，从而“感同身受”，让人们觉察生命的珍贵、健康的重要，进而激发人们的生命激情和自身潜能，提升幸福感。'
      }
    }
  },{
    path: "/Consulting",
    name: "Consulting",
    component: () => import("@/views/Consulting.vue"),
    // meta: {
    //   title: '生命体验教育',
    //   content: {
    //     keywords: '生命教育、生存教育、生活教育、三生体验馆',
    //     description: '通过环境设计或技术辅助，觉醒体验、生理功能剥夺体验、游戏等，让人“设身处地”，从而“感同身受”，让人们觉察生命的珍贵、健康的重要，进而激发人们的生命激情和自身潜能，提升幸福感。'
    //   }
    // }
  },
  {
    path: "/AboutUs",
    name: "AboutUs",
    component: () => import("@/views/AboutUs.vue"),
    meta: {
      title: '青少年儿童心理健康服务平台-好心理',
      content: {
        keywords: '心理、好心理、心理健康、心理咨询、心理治疗',
        description: '北京视觉跳动科技有限公司-好心理， 是青少年儿童提供心理健康服务，为学校、老师、家长、学生提供专业的心理测评、心理健康辅导、心理健康课程、全面普及儿童青少年心理健康教育。提供专家在线咨询和相关技能认证，帮助家长、老师对少年儿童心理咨询和心理治疗的能力提升。'
      }
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
